import Typography from '@material-ui/core/Typography'
import ConfirmationDialog from 'components/ConfirmationDialog/ConfirmationDialog'
import { ProjectPageContext } from 'pages/ProjectsPage/ProjectPage/components/ProjectPageContext'
import React from 'react'
export interface SustainabilityWarningDialogProps {
    isDialogOpen: boolean
    cancelCallback: () => void
    handleElementDeactivation: () => void
}

const SustainabilityWarningDialog: React.FC<SustainabilityWarningDialogProps> = ({
    isDialogOpen,
    cancelCallback,
    handleElementDeactivation,
}) => {
    const { projectData } = React.useContext(ProjectPageContext)

    const [
        isSustainabilityWarningDisplayed,
        setIsSustainabilityWarningDisplayed,
    ] = React.useState<boolean>(isDialogOpen)

    const sustainabilityParameters = React.useMemo(() => {
        const sustainabilityArray = projectData?.getProject?.parameters?.find(
            (parameter) =>
                parameter?.modifierList?.name === 'Sustainability Type'
        )
        return sustainabilityArray?.selectedModifiers?.reduce(
            (prev, modifier, index) => {
                if (index === 0) {
                    return `${modifier.name}`
                }
                return `${prev}, ${modifier.name}`
            },
            ''
        )
    }, [projectData])

    const handleDialogClose = React.useCallback(() => {
        setIsSustainabilityWarningDisplayed(false)
        cancelCallback()
    }, [cancelCallback])

    return (
        <ConfirmationDialog
            openDialog={isSustainabilityWarningDisplayed}
            handleDialogClose={handleDialogClose}
            dialogActionCallback={handleElementDeactivation}
            contentNode={
                <Typography>
                    This action conflicts with the sustainability parameter
                    selected for this project: {sustainabilityParameters}
                </Typography>
            }
            size="small"
            dialogHeading={'Clash Detected!'}
            confirmText={'Yes'}
        />
    )
}

export default SustainabilityWarningDialog
